/**
 * F-180 C13 — minimal cart store for the global NavBar badge.
 *
 * Keeps only what the bottom-nav cart pill needs: `openCartsCount` and
 * setters. The page or hook that loads carts is responsible for
 * priming the count via `setCount()`. WS / poll wiring can later push
 * incremental updates through `increment()` / `decrement()` without
 * touching the store shape.
 */
import { create } from 'zustand';

interface CartState {
  openCartsCount: number;
  setCount: (n: number) => void;
  increment: () => void;
  decrement: () => void;
  reset: () => void;
}

export const useCartStore = create<CartState>((set) => ({
  openCartsCount: 0,
  setCount: (n) => set({ openCartsCount: Math.max(0, n) }),
  increment: () => set((s) => ({ openCartsCount: s.openCartsCount + 1 })),
  decrement: () =>
    set((s) => ({ openCartsCount: Math.max(0, s.openCartsCount - 1) })),
  reset: () => set({ openCartsCount: 0 }),
}));
